/* eslint-disable @typescript-eslint/no-empty-function, @typescript-eslint/no-unused-vars */

import FormWithBehaviors from './FormWithBehaviors';
import {FormProps, FormState} from '../../@types/components/Form';
import handleError from '../../helpers/handleError';
import {UseFormReturn} from 'react-hook-form';
import ValidationHttpException from '../../exceptions/ValidationHttpException';
import {IEmptyModel} from '../../@interfaces/IEmptyModel';

// noinspection JSUnusedLocalSymbols
export default class FormWithSubmitActions<
    Model extends IEmptyModel = IEmptyModel,
    Props extends FormProps<Model> = FormProps<Model>,
    State extends FormState = FormState
> extends FormWithBehaviors<Model, Props, State> {
    constructor(props: Props) {
        super(props);

        this.onSubmit = this.onSubmit.bind(this);
        this.onSubmitPrevented = this.onSubmitPrevented.bind(this);
        this.onSubmitRequestSuccessInForm = this.onSubmitRequestSuccessInForm.bind(this);
        this.onSubmitRequestFailInForm = this.onSubmitRequestFailInForm.bind(this);
    }

    protected async onSubmit(data: Record<string, any>) {
        return this.applyBehavior('onSubmit', data).finally(
            this.onSubmitRequestCompleted.bind(this)
        ).then(
            this.onSubmitRequestSuccess.bind(this),
            this.onSubmitRequestFailure.bind(this),
        );
    }

    protected async onSubmitPrevented(errors: Record<string, any>): Promise<void> {
    }

    protected async onSubmitRequestCompleted(): Promise<void> {
    }

    protected async onSubmitRequestSuccess(res: any): Promise<any> {
        return this.applyBehavior('onSuccess', res);
    }

    protected async onSubmitRequestFailure(error: Error): Promise<any> {
        if (this.hasBehavior('onFail')) {
            return this.applyBehavior('onFail', error);
        }

        handleError(error);

        throw error;
    }

    protected async onSubmitRequestSuccessInForm(response: any, methods: UseFormReturn): Promise<any> {
        return response;
    }

    protected async onSubmitRequestFailInForm(error: Error, methods: UseFormReturn): Promise<any> {
        if (!(error instanceof ValidationHttpException)) {
            throw error;
        }

        const errorsBag = error.getValidationErrors();
        const fields = Object.keys(errorsBag);
        for (let i = 0; i < fields.length; i++) {
            const fieldName = fields[i];
            const errors = errorsBag[fieldName];
            if (!errors.length) {
                continue;
            }

            methods.setError(fieldName, {
                type: 'manual',
                message: errors.at(0) as string
            }, {shouldFocus: !i});
        }
    }
}
